import JSZip from "jszip";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import jwtDecode from "jwt-decode";
import taService from "../services/ta.service";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import {
  limitSettingDocumentsHeader,
  docheader,
  selectDocList,
  businessHeaderv,
} from "../common/fields";

export default function useOnBoardingViewDetails(active = {}) {
  const { Userdata = {}, id, taOnboardingCaseId } = active;
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const history = useHistory();
  const location = useLocation();

  const originalDocHeader = [...docheader];

  const originallimitSettingDocumentsHeaderv = [...limitSettingDocumentsHeader];

  const initialUpload = {
    aadhar_front: "",
    aadhar_back: "",
    pan: "",
    firm_pan: "",
    passport_photo: "",
    business_proof_1: "",
    business_proof_2: "",
    ksos_cheque_1: "",
    ksos_cheque_2: "",
    tyger_cheque_1: "",
    tyger_cheque_2: "",
    bank_statement: "",
    itr_year_1: "",
    itr_year_2: "",
    partnership_deed: "",
  };

  const initialValues = {
    taOnboardingCaseId: "",
    businessType: "",
    businessExperienceYears: "",
    noOfPartners: 0,
    companyName: "",
    taUserPhone: Userdata?.phone,
    personName: Userdata?.userName,
    officeType: "",
    yardDetails: "",
    email: "",
    companyAddress: "",
    vintageWithMeratractorYears: "",
    monthlyAverageSalesUnit: "",
    maritalStatusOfApplicant: "",
    residenceType: "",
    residentialStabilityYears: "",
    monthlyAverageSalesVolume: "",
    reference1Name: "",
    reference1Phone: "",
    reference2Name: "",
    reference2Phone: "",
    brokerBackground: "",
    dealingInList: "",
    financiers: "",
    yardForStocking: "",
    userPan: Userdata?.pan,
    associatedFinanciers: "",
    businessProof1Name: Userdata?.businessProof1Name,
    businessProof2Name: Userdata?.businessProof2Name,
    state: Userdata?.state_name,
    dealingInTractor: false,
    dealingInCv: false,
    dealingIn2w: false,
  };

  const [ID, setId] = useState();
  const [selected, setSelected] = useState("buss");
  const [debounceVal, setDebounceVal] = useState("");
  const [showDocList, setShowDocList] = useState(false);
  const [taUserDetails, setTAUserDetails] = useState("");
  const [formData, setFormData] = useState(initialValues);
  const [formUpload, setFormUpload] = useState(initialUpload);
  const [loadingTADetails, setLoadingTADetails] = useState(true);
  const [loadingbusDetails, setLoadingbusDetails] = useState(false);
  const [filterTAUserDetails, setFilterTAUserDetails] = useState("");
  const [docHeader, setDocHeader] = useState([...originalDocHeader]);
  const [businessProofSelections, setBusinessProofSelections] = useState({
    businessProof1Name: Userdata?.businessProof1Name,
    businessProof2Name: Userdata?.businessProof2Name,
    itrYear1Available: Userdata?.itrYear1Available === true ? "Yes" : "No",
    itrYear2Available: Userdata?.itrYear2Available === true ? "Yes" : "No",
  });
  const [limitSettingDocHeader, setLimitSettingDocHeader] = useState([
    ...originallimitSettingDocumentsHeaderv,
  ]);

  useEffect(() => {
    if (id) {
      setId(id);
    } else if (taOnboardingCaseId) {
      setId(taOnboardingCaseId);
    }
  }, [id, taOnboardingCaseId]);

  const handleUpload = async (e, name, docId, id, isRequired, header, partnerID = null) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;

      const caseId = id || taOnboardingCaseId;
      if (!caseId) {
        errorToast("Please update business details first");
        return;
      }

      const fileURL = URL.createObjectURL(file);
      const fileType = file.type;
      let filePreviewHTML = "";
      if (fileType === "application/pdf") {
        filePreviewHTML = `<iframe src="${fileURL}" width="100%" height="400px" style="border:1px solid #ccc;"></iframe>`;
      } else if (fileType.startsWith("image/")) {
        filePreviewHTML = `<img src="${fileURL}" style="max-width:100%; max-height:400px; border:1px solid #ccc;" />`;
      } else if (
        file.name.endsWith(".doc") ||
        file.name.endsWith(".docx") ||
        fileType === "application/msword" ||
        fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        filePreviewHTML = `<p><a href="${fileURL}" target="_blank">Click here to preview the DOC file</a></p>`;
      } else {
        filePreviewHTML = `<p>File preview not supported. Click "Upload" to continue.</p>`;
      }
      const result = await Swal.fire({
        title: "Confirm Upload",
        html: `
          <p>You are about to upload: <strong>${file.name} for ${header}</strong></p>
          ${filePreviewHTML}
        `,
        showCancelButton: true,
        confirmButtonText: "Yes, Upload it!",
        cancelButtonText: "Cancel",
        width: 600,
        heightAuto: false,
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();
          formData.append("taOnboardingCaseId", caseId);
          formData.append(name, file);

          try {
            let response;

            // Use different API endpoint for partner documents
            if (partnerID) {
              const partnerFormData = new FormData();
              partnerFormData.append("partnerId", partnerID);
              partnerFormData.append(name, file);
              response = await taService.UploadPartnerDoc(partnerFormData);
            } else {
              response = await taService.UploadDoc(formData);
            }
            if (response?.status === 200) {
              successToast(response?.msg);

              // Update partner documents if partnerID is provided
              if (partnerID) {
                const updatedPartnerDetails = taUserDetails.partnerDetails.map((partner) => {
                  if (partner.partnerID === partnerID) {
                    const updatedDocs = partner.documents.map((doc) =>
                      doc.documentName === name
                        ? {
                          ...doc,
                          documentId: response?.documentId,
                          documentPath: response?.link,
                          isUploaded: true,
                          isRejected: false,
                          isApproved: response?.isApproved || false,
                          rejectionRemarks: "",
                        }
                        : doc
                    );

                    return {
                      ...partner,
                      documents: updatedDocs,
                      docCounts: {
                        totalDoc: response?.totalDoc || updatedDocs.length,
                        verified: response?.verified || updatedDocs.filter(d => d.isApproved).length,
                        pending: response?.pending || updatedDocs.filter(d => d.isUploaded && !d.isApproved && !d.isRejected).length,
                        missing: response?.missing || updatedDocs.filter(d => !d.isUploaded).length,
                        rejected: response?.rejected || updatedDocs.filter(d => d.isRejected).length
                      }
                    };
                  }
                  return partner;
                });

                setTAUserDetails((prev) => ({
                  ...prev,
                  partnerDetails: updatedPartnerDetails,
                  verified: response?.verified,
                  pending: response?.pending,
                  missing: response?.missing,
                  rejected: response?.rejected,
                  totalDoc: response?.totalDoc,
                }));

                setFilterTAUserDetails((prev) => ({
                  ...prev,
                  partnerDetails: updatedPartnerDetails,
                  verified: response?.verified,
                  pending: response?.pending,
                  missing: response?.missing,
                  rejected: response?.rejected,
                  totalDoc: response?.totalDoc,
                }));
                
              } else {
                // Original logic for main documents
                const updatedDocuments = taUserDetails.documents.map((item) =>
                  item.documentName === name
                    ? {
                      ...item,
                      documentID: response?.documentId,
                      documentPath: response?.link,
                      isUploaded: true,
                      isRejected: false,
                      isApproved: response?.isApproved,
                      rejectionRemarks: "",
                    }
                    : item
                );
                setTAUserDetails((prev) => ({
                  ...prev,
                  documents: updatedDocuments,
                  rejected: response.rejected,
                  missing: response.missing,
                  pending: response.pending,
                  verified: response.verified,
                  totalDoc: response.totalDoc,
                }));

                setFilterTAUserDetails((prev) => ({
                  ...prev,
                  documents: updatedDocuments,
                  rejected: response.rejected,
                  missing: response.missing,
                  pending: response.pending,
                  verified: response.verified,
                  totalDoc: response.totalDoc,
                }));
              }
            } else {
              errorToast(response?.msg);
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
      });

      if (!result.isConfirmed || !result.value) {
        e.target.value = null;
        URL.revokeObjectURL(fileURL);
        return;
      }

      URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Upload error:", error);
      errorToast("An error occurred during upload.");
    }
  };

  const handleVerifiedrRejected = async (
    e,
    id,
    docId,
    status,
    field,
    header,
    partnerID = null
  ) => {
    if (status === "approve") {
      const auctionText = `You want to Verify ${header}`;
      Swal.fire({
        title: "Are you sure?",
        html: auctionText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Approve it!",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            let response;

            // Use different API endpoint for partner documents
            if (partnerID) {
              const partnerFormData = new FormData();
              partnerFormData.append("partnerId", partnerID);
              partnerFormData.append("documentId", docId);
              partnerFormData.append("status", status);
              response = await taService.ApproveRejectPartnerDoc(partnerFormData);
            } else {
              const formData = new FormData();
              formData.append("taOnboardingCaseId", id);
              formData.append("documentId", docId);
              formData.append("status", status);
              response = await taService.VerifyOrRejectDocumentsByBA(formData);
            }
            if (response?.status === 200) {
              successToast(response?.msg);

              // Update partner documents if partnerID is provided
              if (partnerID) {
                const updatedPartnerDetails = taUserDetails.partnerDetails.map((partner) => {
                  if (partner.partnerID === partnerID) {
                    const updatedDocs = partner.documents.map((doc) =>
                      doc.documentId === docId
                        ? {
                          ...doc,
                          isUploaded: true,
                          isRejected: false,
                          isApproved: true,
                          rejectionRemarks: "",
                        }
                        : doc
                    );

                    // Update document counts
                    const verified = updatedDocs.filter(d => d.isApproved).length;
                    const pending = updatedDocs.filter(d => d.isUploaded && !d.isApproved && !d.isRejected).length;
                    const missing = updatedDocs.filter(d => !d.isUploaded).length;
                    const rejected = updatedDocs.filter(d => d.isRejected).length;

                    return {
                      ...partner,
                      documents: updatedDocs,
                      docCounts: {
                        totalDoc: updatedDocs.length,
                        verified,
                        pending,
                        missing,
                        rejected
                      }
                    };
                  }
                  return partner;
                });

                setTAUserDetails((prev) => ({
                  ...prev,
                  partnerDetails: updatedPartnerDetails,
                  verified: response?.verified,
                  pending: response?.pending,
                  missing: response?.missing,
                  rejected: response?.rejected,
                  totalDoc: response?.totalDoc,
                }));

                setFilterTAUserDetails((prev) => ({
                  ...prev,
                  partnerDetails: updatedPartnerDetails,
                  verified: response?.verified,
                  pending: response?.pending,
                  missing: response?.missing,
                  rejected: response?.rejected,
                  totalDoc: response?.totalDoc,
                }));
              } else {
                // Original logic for main documents
                const updatedDocuments = taUserDetails.documents.map((item) => {
                  if (item.documentID === docId) {
                    return {
                      ...item,
                      isUploaded: true,
                      isRejected: false,
                      isApproved: true,
                      rejectionRemarks: "",
                    };
                  }
                  return item;
                });

                setTAUserDetails((prev) => ({
                  ...prev,
                  documents: updatedDocuments,
                  pending: prev?.pending - 1,
                  verified: prev?.verified + 1,
                }));

                setFilterTAUserDetails((prev) => ({
                  ...prev,
                  documents: updatedDocuments,
                  pending: prev?.pending - 1,
                  verified: prev?.verified + 1,
                }));
              }
            }
          } catch (error) {
            Swal.showValidationMessage(`Request failed: ${error}`);
          }
        },
      });
    } else {
      const auctionText = `You want to Reject ${header}`;
      Swal.fire({
        title: "Are you sure?",
        html: auctionText,
        icon: "warning",
        showCancelButton: true,
        inputLabel: "Rejection Reason",
        input: "text",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Reject it!",
        showLoaderOnConfirm: true,
        preConfirm: async (rejectionReason) => {
          if (!rejectionReason) {
            Swal.showValidationMessage("Rejection reason is required");
            return false;
          }

          try {
            let response;

            // Use different API endpoint for partner documents
            if (partnerID) {
              const partnerFormData = new FormData();
              partnerFormData.append("partnerId", partnerID);
              partnerFormData.append("documentId", docId);
              partnerFormData.append("status", status);
              partnerFormData.append("rejectionRemarks", rejectionReason);
              response = await taService.ApproveRejectPartnerDoc(partnerFormData);
            } else {
              const formData = new FormData();
              formData.append("taOnboardingCaseId", id);
              formData.append("documentId", docId);
              formData.append("status", status);
              formData.append("rejectionRemarks", rejectionReason);
              response = await taService.VerifyOrRejectDocumentsByBA(formData);
            }

            if (response?.status === 200) {
              successToast(response?.msg);

              // Update partner documents if partnerID is provided
              if (partnerID) {
                const updatedPartnerDetails = taUserDetails.partnerDetails.map((partner) => {
                  if (partner.partnerID === partnerID) {
                    const updatedDocs = partner.documents.map((doc) =>
                      doc.documentId === docId
                        ? {
                          ...doc,
                          isUploaded: true,
                          isRejected: true,
                          isApproved: false,
                          rejectionRemarks: rejectionReason,
                        }
                        : doc
                    );

                    // Update document counts
                    const verified = updatedDocs.filter(d => d.isApproved).length;
                    const pending = updatedDocs.filter(d => d.isUploaded && !d.isApproved && !d.isRejected).length;
                    const missing = updatedDocs.filter(d => !d.isUploaded).length;
                    const rejected = updatedDocs.filter(d => d.isRejected).length;

                    return {
                      ...partner,
                      documents: updatedDocs,
                      docCounts: {
                        totalDoc: updatedDocs.length,
                        verified,
                        pending,
                        missing,
                        rejected
                      }
                    };
                  }
                  return partner;
                });

                setTAUserDetails((prev) => ({
                  ...prev,
                  partnerDetails: updatedPartnerDetails,
                  verified: response?.verified,
                  pending: response?.pending,
                  missing: response?.missing,
                  rejected: response?.rejected,
                  totalDoc: response?.totalDoc,
                }));

                setFilterTAUserDetails((prev) => ({
                  ...prev,
                  partnerDetails: updatedPartnerDetails,
                  verified: response?.verified,
                  pending: response?.pending,
                  missing: response?.missing,
                  rejected: response?.rejected,
                  totalDoc: response?.totalDoc,
                }));
              } else {
                // Original logic for main documents
                const updatedDocuments = taUserDetails.documents.map((item) => {
                  if (item.documentID === docId) {
                    return {
                      ...item,
                      isUploaded: true,
                      isRejected: true,
                      isApproved: false,
                      rejectionRemarks: rejectionReason,
                    };
                  }
                  return item;
                });

                setFilterTAUserDetails((prev) => ({
                  ...prev,
                  documents: updatedDocuments,
                  pending: prev?.pending - 1,
                  rejected: prev?.rejected + 1,
                }));
                setTAUserDetails((prev) => ({
                  ...prev,
                  documents: updatedDocuments,
                  pending: prev?.pending - 1,
                  rejected: prev?.rejected + 1,
                }));
              }
            } else {
              errorToast(response?.msg);
            }
          } catch (error) {
            Swal.showValidationMessage(`Request failed: ${error}`);
          }
        },
      });
    }
  };

  const handleVerifiedrRejectedBusDetails = async (e, id, status) => {
    if (status === "approve") {
      setLoadingbusDetails(true);
      const formData = new FormData();
      formData.append("taOnboardingCaseId", id);
      formData.append("status", status);
      const response = await taService.VerifyOrRejectBusDetailsByBA(formData);

      if (response?.status === 200) {
        setLoadingbusDetails(false);
        successToast(response?.msg);
        const updatedDocuments = {
          ...taUserDetails,
          documentID: response?.documentID,
          isCaseBusinessDetailsApprovedByBa: true,
        };
        setTAUserDetails(updatedDocuments);
        setFilterTAUserDetails(updatedDocuments);
      } else {
        setLoadingbusDetails(false);
        errorToast(response?.msg);
      }
    } else {
      const auctionText = "You want to Reject  ";
      Swal.fire({
        title: "Are you sure?",
        html: auctionText,
        icon: "warning",
        showCancelButton: true,
        inputLabel: "Rejection Reason",
        input: "text",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Reject it!",
        showLoaderOnConfirm: true,
        preConfirm: async (rejectionReason) => {
          if (!rejectionReason) {
            Swal.showValidationMessage("Rejection reason is required");
            return false;
          }

          const formData = new FormData();
          formData.append("taOnboardingCaseId", id);
          formData.append("status", status);
          formData.append("rejectionRemarks", rejectionReason);

          try {
            const response = await taService.VerifyOrRejectBusDetailsByBA(
              formData
            );
            setLoadingbusDetails(false);
            if (response?.status === 200) {
              successToast(response?.msg);
              const updatedDocuments = {
                ...taUserDetails,
                documentID: response?.documentID,
                isCaseBusinessDetailsRejectedByBa: true,
                caseBusinessDetailsRejectionReason: rejectionReason,
              };

              setTAUserDetails(updatedDocuments);
              setFilterTAUserDetails(updatedDocuments);
            } else {
              errorToast(response?.msg);
            }
          } catch (error) {
            Swal.showValidationMessage(`Request failed: ${error}`);
          }
        },
      });
    }
  };

  const handleVerifyAll = async (e, id, status) => {
    const auctionText = `You want to verify all`;
    Swal.fire({
      title: "Are you sure?",
      html: auctionText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Verify All!",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const formData = new FormData();
        formData.append("taOnboardingCaseId", id);
        try {
          const response = await taService.VerifyCaseByBA(formData);
          if (response?.status === 200) {
            successToast(response?.msg);
            const updatedDocuments = {
              ...taUserDetails,
              isCaseBusinessDetailsApprovedByBa: true,
            };
            setTAUserDetails(updatedDocuments);
            setFilterTAUserDetails(updatedDocuments);
            window.location.reload();
          } else {
            errorToast(response?.msg);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingTADetails(true);
        const formData = new FormData();
        formData.append("taOnboardingCaseId", ID);
        const response = await taService.GetTACaseDetails(formData);
        if (response?.status === 200) {
          if (
            response?.data?.isCaseBusinessDetailsRejectedByBa &&
            user?.role === "Auction Representative"
          ) {
            history?.push(
              `/auction_representative/user_home/manage-ta-onboard/update-ta-user:${response?.data?.taOnboardingCaseId}`
            );
            setTAUserDetails(response.data);
            const businessTypeMap = {
              individual: "Individual",
              proprietor: "Proprietor",
              partnership: "Partnership",
              pvt_ltd: "Private limited (Pvt Ltd)",
            };
            const dealingInListMap = {
              CV: "cv",
              Tractor: "tractor",
              "2 Wheeler": "2w",
            };
            const capitalizeWords = (str) =>
              str
                ?.toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");

            const normalizedDealingInList = (
              response.data.dealingInList || []
            ).map((item) => {
              const trimmed = item?.trim().toLowerCase();

              return dealingInListMap[trimmed] || capitalizeWords(trimmed);
            });
            setFilterTAUserDetails({
              ...response.data,
              userPan: response?.data?.pan,
              businessType:
                businessTypeMap[response.data.businessType] ||
                response.data.businessType,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });

            setFormData((prev) => ({
              ...prev,
              ...response.data,
              userPan: response?.data?.pan,
            }));
            setFormUpload(response?.data?.documents);
            setBusinessProofSelections({
              bankStatementPassword: response?.data?.bankStatementPassword,
              businessProof1Name: response?.data?.businessProof1Name,
              businessProof2Name: response?.data?.businessProof2Name,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });
            setLoadingTADetails(false);
          } else {
            setTAUserDetails(response.data);
            const businessTypeMap = {
              individual: "Individual",
              proprietor: "Proprietor",
              partnership: "Partnership",
              pvt_ltd: "Private limited (Pvt Ltd)",
            };

            setFilterTAUserDetails({
              ...response.data,
              userPan: response?.data?.pan,
              businessType:
                businessTypeMap[response.data.businessType] ||
                response.data.businessType,

              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });

            setFormData((prev) => ({
              ...prev,
              ...response.data,
              userPan: response?.data?.pan,
            }));
            setFormUpload(response?.data?.documents);
            setBusinessProofSelections({
              bankStatementPassword: response?.data?.bankStatementPassword,
              businessProof1Name: response?.data?.businessProof1Name,
              businessProof2Name: response?.data?.businessProof2Name,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });
            setLoadingTADetails(false);
          }
        } else {
          setLoadingTADetails(false);
          errorToast(response?.msg);
        }
      } catch (error) {
        errorToast(error?.msg || "Something went wrong");
        setLoadingTADetails(false);
      }
    };

    if (ID) {
      fetchData();
    }
  }, [ID]);

  const handleBusinessProofChange = async (selected, key) => {
    let newSelection;
    const formData = new FormData();
    if (key === "itrYear1Available" || key === "itrYear2Available") {
      if (selected === "Yes") {
        newSelection = {
          ...businessProofSelections,
          [key]: true,
        };
      } else if (selected === "No") {
        newSelection = {
          ...businessProofSelections,
          [key]: false,
        };
      }
    } else {
      newSelection = {
        ...businessProofSelections,
        [key]: selected,
      };
    }

    formData.append(key, newSelection[key]);
    formData.append("taOnboardingCaseId", ID);
    const response = await taService.GlobalUpdateTaCaseField(formData);
    if (response?.status === 200) {
      setBusinessProofSelections((prev) => ({ ...prev, [key]: selected }));

      setFilterTAUserDetails((...prev) => ({
        ...prev[0],
        [key]: selected,
      }));
    } else {
      errorToast(response?.msg);
    }
  };

  useEffect(() => {
    const updateBusinessProof = async () => {
      if (debounceVal !== "") {
        try {
          const formData = new FormData();
          formData.append("bankStatementPassword", debounceVal);
          formData.append("taOnboardingCaseId", ID);

          const response = await taService.GlobalUpdateTaCaseField(formData);
          if (response?.status === 200) {
            setBusinessProofSelections((prev) => ({
              ...prev,
              ["bankStatementPassword"]: debounceVal,
            }));
          } else {
            errorToast(response?.msg);
          }
        } catch (error) {
          errorToast(error?.message || "Something went wrong");
        }
      }
    };

    updateBusinessProof();
  }, [debounceVal]);

  function debounce(cb, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const debouncedChange = useCallback(
    debounce((inputValue) => {
      setDebounceVal(inputValue);
    }, 900),
    []
  );

  const handleChangePassword = (e) => {
    const { name, value } = e.target;
    debouncedChange(value);
    setFilterTAUserDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeleteCase = async (e, id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this case?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        focusCancel: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();

          formData.append("taOnboardingCaseId", id);

          try {
            const response = await taService.DeleteTACase(formData);
            if (response?.status === 200) {
              successToast(response?.msg);
              history.push(
                `/business_analyst:${user?.phone}&state=${user?.state}`
              );
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.error("Error deleting partner:", error);
      errorToast("An error occurred while deleting the partner.");
    }
  };

  const handleSearch = (e) => {
    const { name, value } = e?.target;
    const searchData = originalDocHeader?.filter((val) => {
      const match = val?.header?.toLowerCase().includes(value?.toLowerCase());

      return match;
    });
    setDocHeader(searchData);
  };
  const handleSearchLimitSetting = (e) => {
    const { name, value } = e?.target;
    const searchData = originallimitSettingDocumentsHeaderv?.filter((val) => {
      const match = val?.header?.toLowerCase().includes(value?.toLowerCase());

      return match;
    });

    setLimitSettingDocHeader(searchData);
  };

  function getUrlExtension(url) {
    const pathname = new URL(url).pathname;
    const lastPart = pathname.split("/").pop();
    const dotIndex = lastPart.lastIndexOf(".");
    return dotIndex !== -1 ? lastPart.substring(dotIndex) : ".jpg";
  }
  const downloadDocumentsAsZip = async (documents) => {
    try {
      const zip = new JSZip();

      const zipFileName = `${filterTAUserDetails?.personName}-${filterTAUserDetails?.userState}`;

      const fetchPromises = documents.map(async (doc) => {
        try {
          const response = await fetch(doc?.documentPath, { method: "GET" });
          const blob = await response.blob();
          const ext = getUrlExtension(doc?.documentPath);
          zip.file(`${doc?.documentName}${ext}`, blob); // Directly in ZIP root
        } catch (error) {
          console.error("Error fetching document:", error);
        }
      });

      await Promise.all(fetchPromises);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${zipFileName}.zip`);
    } catch (error) {
      console.log(error);
      errorToast(error);
    }
  };
  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();

      if (user?.role === "Auction Representative") {
        history.push("/auction_representative/user_home/manage-ta-onboard");
      } else if (user?.role === "Business Analyst") {
        history.push(`/business_analyst:${user?.phone}&state=${user?.state}`);
      } else {
        history.goBack();
      }
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [user, history]);

  return {
    selected,
    setSelected,
    loadingTADetails,
    handleUpload,
    handleVerifiedrRejected,
    handleVerifiedrRejectedBusDetails,
    loadingbusDetails,
    filterTAUserDetails,
    handleBusinessProofChange,
    businessProofSelections,
    handleChangePassword,
    handleDeleteCase,
    handleVerifyAll,
    showDocList,
    downloadDocumentsAsZip,
    selectDocList,
    setShowDocList,
    setDocHeader,
    originalDocHeader,
    setLimitSettingDocHeader,
    originallimitSettingDocumentsHeaderv,
    handleSearch,
    docHeader,
    businessHeaderv,
    handleSearchLimitSetting,
    limitSettingDocHeader,
  };
}
